var React = require('react');

function CommentAltMinus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 0H64A64.06 64.06 0 0 0 0 64v288a64.06 64.06 0 0 0 64 64h96v84a12 12 0 0 0 19.1 9.7L304 416h144a64.06 64.06 0 0 0 64-64V64a64.06 64.06 0 0 0-64-64zm-80 216a16 16 0 0 1-16 16H160a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M144 200a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H160a16 16 0 0 1-16-16z","className":"fa-primary","key":2})]);
}

CommentAltMinus.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CommentAltMinus;

CommentAltMinus.default = CommentAltMinus;
